import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Form } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ContentBlockerTemplateForm } from "./contentBlockerTemplateForm.js";
import { useContentBlockerTemplateCreate } from "../../../../../hooks/content-blocker/useContentBlockerTemplateCreate.js";
import { useFormValidation } from "../../../../../hooks/form/useFormValidation.js";
import { useTranslation } from "../../../../../others/i18n.js";
import { useStores } from "../../../../../store/root.js";
function ContentBlockerTemplateCreate() {
    const { t } = useTranslation();
    const { notificationStore } = useStores();
    const navigate = useNavigate();
    const [contentBlockerTemplateToCreate, setContentBlockerTemplateToCreate] = useState();
    const [templateForm] = Form.useForm();
    const [validationErrors, setValidationErrors] = useState(undefined);
    useFormValidation(templateForm, validationErrors);
    const useCreateContentBlockerTemplate = useContentBlockerTemplateCreate(contentBlockerTemplateToCreate);
    const [isSubmitting, setSubmitting] = useState(false);
    useEffect(()=>{
        const { data, error, isError, isSuccess } = useCreateContentBlockerTemplate;
        if (isSuccess && data && !isNaN(Number(data.id))) {
            notificationStore.clearAll();
            setValidationErrors(undefined);
            const search = new URLSearchParams({
                headline: data.headline
            }).toString();
            navigate({
                pathname: "/rcb/content-blocker",
                search: `?${search}`
            });
        } else if (isError && error) {
            notificationStore.clearAll();
            setValidationErrors(error);
            notificationStore.addFromServerError(error, t);
        }
    }, [
        useCreateContentBlockerTemplate,
        contentBlockerTemplateToCreate
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Breadcrumb, {
                items: [
                    {
                        href: "/rcb",
                        title: /*#__PURE__*/ _jsx(HomeOutlined, {})
                    },
                    {
                        href: "/rcb/content-blocker",
                        title: /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(UserOutlined, {}),
                                /*#__PURE__*/ _jsx("span", {
                                    children: t("Content Blocker")
                                })
                            ]
                        })
                    },
                    {
                        title: t("Create")
                    }
                ]
            }),
            /*#__PURE__*/ _jsx(ContentBlockerTemplateForm, {
                isSubmitting: isSubmitting,
                isLoading: useCreateContentBlockerTemplate.isFetching,
                contentBlockerTemplate: undefined,
                templateForm: templateForm,
                onSubmit: (template)=>{
                    template["_lastSubmit"] = new Date().getTime();
                    setSubmitting(true);
                    setContentBlockerTemplateToCreate(template);
                }
            })
        ]
    });
}
export { ContentBlockerTemplateCreate };
